import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';
var url = '';

if (process.env.NODE_ENV === 'development') {
  url = "http://".concat(window.location.hostname, ":3334");
} else {
  url = "https://".concat(window.location.hostname);
}

export default (function (_ref) {
  var Vue = _ref.Vue;
  var socket = io(url);
  Vue.use(VueSocketIOExt, socket);
});